import { request } from '../util/request'

export const homeData = () => {
  return request({
    url: '/statistic/home',
    method: 'get',
  })
}

export const blockData = () => {
  return request({
    url: '/statistic/block',
    method: 'get',
  })
}

export const transferData = () => {
  return request({
    url: '/statistic/transfer',
    method: 'get',
  })
}

export const accountData = () => {
  return request({
    url: '/statistic/account',
    method: 'get',
  })
}

export const transactionData = () => {
  return request({
    url: '/statistic/transaction',
    method: 'get',
  })
}
